import React, { useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { Collapse } from "react-collapse";
import "./FireOrigin.css";
import { ConfigProvider, TimePicker } from "antd";
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr";
import { enUS } from "date-fns/locale/en-US";
import { useTranslation } from "react-i18next";
import { useAntdLocale } from "../../../utils/DateTimeUtils";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
registerLocale("fr", fr);
registerLocale("en", enUS);
const FireOrigin = ({
  openSection,
  dfciCode,
  setDfciCode,
  toggleFirstSection,
  formattedCurrentDate,
  formattedCurrentTime,
  onChangeOriginFireRef,
  onChangeOriginFireDate,
  onChangeOriginFireHour,
  onChangeOriginFireLocation,
  originFireRef,
  originFireDate,
  originFireHour,
  originFireLocation,
  operationId,
  triggerTooltip,
  getPoints,
  validateFirstSection,
  geocoderContainerRefSidebar,
}) => {
  const { t, i18n } = useTranslation();
  const antdLocale = useAntdLocale();
  const dateLocale = i18n.language?.startsWith("fr") ? "fr" : "en";
  useEffect(() => {
    if (!originFireDate) {
      onChangeOriginFireDate(formattedCurrentDate);
    }
    /*   if (!originFireHour) {
      onChangeOriginFireHour(formattedCurrentTime);
    } */
  }, [
    formattedCurrentDate,
    formattedCurrentTime,
    originFireDate,
    originFireHour,
    onChangeOriginFireDate,
    //onChangeOriginFireHour,
  ]);

  const handleDfciInputChange = (e) => {
    setDfciCode(e.target.value);
  };
  const handleOriginFireDateChange = (date) => {
    if (date) {
      const formatted = date.toISOString().split("T")[0]; // Format as yyyy-mm-dd
      onChangeOriginFireDate(formatted);
    }
  };

  const handleOriginFireHourChange = (time) => {
    if (time) {
      const formattedTime = time.format("HH:mm");
      onChangeOriginFireHour(formattedTime);
    }
  };
  const handleOriginFireRefChange = (e) => {
    onChangeOriginFireRef(e.target.value); // Store the input as a string
  };
  const handleFormSubmit = (e) => {
    e.preventDefault(); // Prevent page reload
    if (!originFireRef) {
      triggerTooltip(t("eventCreation.origin.errors.missingReference"));
      return;
    }
    if (!originFireDate) {
      triggerTooltip(t("eventCreation.origin.errors.missingDate"));
      return;
    }
    if (!originFireHour) {
      triggerTooltip(t("eventCreation.origin.errors.missingHour"));
      return;
    }
    const points = getPoints(); // Get drawn polygons
    if (!points || points.length === 0) {
      triggerTooltip(t("eventCreation.origin.errors.missingOrigin"));
      return;
    }

    toggleFirstSection(); // Handle the toggle logic (check if toggleFirstSection is defined and works properly)
    validateFirstSection();
  };

  const currentDate = new Date();

  const minDate = new Date(currentDate.getFullYear(), 6, 1); // month index 6 = July

  // Calculate the date 24 hours from now
  const maxDate = new Date(currentDate);

  return (
    <div>
      <Collapse isOpened={openSection === "origin"}>
        <Form className="form" onSubmit={handleFormSubmit} autoComplete="off">
          <Form.Group className="form-group-custom">
            <Form.Label>
              {t("eventCreation.origin.referenceLabel")}
              <b style={{ color: "red", fontSize: "16px" }}>&nbsp;*</b>
            </Form.Label>
            <Form.Control
              className="form-control-own"
              type="text"
              placeholder={t("eventCreation.origin.referencePlaceholder")}
              value={originFireRef || ""}
              onChange={handleOriginFireRefChange}
              data-testid="create-event-reference-input"
            />
          </Form.Group>
          <Form.Group className="form-group-custom">
            <Form.Label>
              {t("eventCreation.origin.dateLabel")}
              <b style={{ color: "red", fontSize: "16px" }}>&nbsp;*</b>
            </Form.Label>
            <DatePicker
              selected={originFireDate}
              locale={dateLocale}
              className="date-input"
              dateFormat={dateLocale === "fr" ? "dd/MM/yyyy" : "MM/dd/yyyy"}
              value={originFireDate || formattedCurrentDate}
              onChange={handleOriginFireDateChange}
              minDate={minDate}
              maxDate={maxDate}
              data-testid="create-event-date-input"
            />
          </Form.Group>
          <Form.Group className="form-group-custom">
            <Form.Label>
              {t("eventCreation.origin.hourLabel")}
              <b style={{ color: "red", fontSize: "16px" }}>&nbsp;*</b>
            </Form.Label>

            <ConfigProvider locale={antdLocale}>
              <TimePicker
                className="time-input"
                style={{ width: "100%", height: "30px" }}
                format="HH:mm"
                placeholder={t("eventCreation.origin.hourPlaceholder")}
                value={originFireHour ? dayjs(originFireHour, "HH:mm") : null}
                onSelect={handleOriginFireHourChange}
                data-testid="create-event-time-input"
              />
            </ConfigProvider>
          </Form.Group>
          <div className="localisation-div">
            <p className="localisation-title">
              {t("eventCreation.origin.locationTitle")}
            </p>
            <div className="localisation-inputs-div">
              <Form.Group className="form-group-custom-two">
                <Form.Label>
                  {t("eventCreation.origin.addressLabel")}
                </Form.Label>
                <div className="sidebar-geocoder">
                  <div
                    ref={geocoderContainerRefSidebar}
                    className="geocoder-container"
                    value={originFireLocation}
                    // onChange={handleOriginFireLocationChange}
                    data-testid="create-event-address-input"
                  />
                </div>
              </Form.Group>
              <Form.Group className="form-group-custom-two">
                <Form.Label>
                  {t("eventCreation.origin.dfciCodeLabel")}
                </Form.Label>
                <Form.Control
                  className="form-control-own-two"
                  type="text"
                  placeholder={t("eventCreation.origin.dfciCodePlaceholder")}
                  value={dfciCode}
                  onChange={handleDfciInputChange}
                  data-testid="create-event-dfci-code-input"
                />
              </Form.Group>
            </div>
          </div>
          <p className="note-origin">{t("eventCreation.origin.mapNote")}</p>
          <Button
            type="submit"
            className="event-btn sidebar-primary-btn"
            data-testid="create-event-validate-button"
          >
            {t("eventCreation.origin.validate")}
          </Button>
        </Form>
      </Collapse>
    </div>
  );
};

export default React.memo(FireOrigin);
